import React from "react"

import styles from "./Overlay.module.scss"

const Overlay = ({ overlay, custom }) => {
  const backgroundStyles =
    custom === "gradient"
      ? `linear-gradient(110deg, ${overlay.color} 20%, rgba(255,255,255,0) 70%)`
      : overlay.color
  return (
    <div
      className={styles.item}
      style={{ background: backgroundStyles, opacity: overlay.opacity }}
    ></div>
  )
}

export default Overlay
